import { useSelector } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'
import { IGetCalendarEvent } from '@interfaces/CalendarEvents'
import moment from 'moment'
import { DATE_FORMAT } from '@utils/constants'
import { DOWNLOAD_CAL_BTN_PROPS } from '@components/DownloadCalendarButton/constants'
import PortalCalendarEvents from '@classes/CalendarEvents'

const useCalendarEvents = (calendarEvents: IGetCalendarEvent[]) => {
  const { profile, MyBerlitzEnvironment } = useSelector(({ userProfile }: StoreProps) => ({
    profile: userProfile.info,
    MyBerlitzEnvironment: userProfile.info.StudentProfile.StudentProfileInfo.MyBerlitzEnvironment,
  }))

  const getCalendarEventsPayload = () => ({
    studentProfileId: profile?.SFId,
  })

  const updateStudentPayload = (getDateWithUserTimezone: (date?: string) => moment.Moment) => ({
    studentInput: [
      {
        StudentProfileInfo: {
          RecordId: calendarEvents[0]?.StudentCalendarEventInfo?.StudentRecordId,
          Student: profile.StudentProfile.StudentProfileInfo.Student,
          LastCalendarExport: getDateWithUserTimezone().utc().format(DATE_FORMAT.TZ),
        },
      },
    ],
  })

  const getDownloadButtons = () => ['Outlook', ...(MyBerlitzEnvironment === 'China' ? [] : ['Google']), 'iCal']

  const getBtnProps = (downloaded: boolean) => {
    const { LastCalendarExport, LastCalendarEventUpdate } = calendarEvents?.[0]?.StudentCalendarEventInfo!
    const hasChanges =
      !!LastCalendarExport && moment(LastCalendarEventUpdate).format('X') > moment(LastCalendarExport).format('X')
    const isDownloaded =
      (downloaded || LastCalendarExport === LastCalendarEventUpdate) &&
      calendarEvents?.some((event) => !!event?.StudentCalendarEventInfo?.SessionScheduleInfos?.length)
    return hasChanges
      ? DOWNLOAD_CAL_BTN_PROPS.hasChanges
      : isDownloaded
        ? DOWNLOAD_CAL_BTN_PROPS.downloaded
        : DOWNLOAD_CAL_BTN_PROPS.default
  }

  const generateICS = () => {
    return new PortalCalendarEvents(calendarEvents, profile?.StudentProfile?.StudentProfileInfo).ICS
  }

  const hasNoSessions = () =>
    calendarEvents?.some((event) => !event?.StudentCalendarEventInfo?.SessionScheduleInfos?.length)

  return {
    getCalendarEventsPayload,
    updateStudentPayload,
    getDownloadButtons,
    getBtnProps,
    generateICS,
    hasNoSessions,
  }
}

export default useCalendarEvents
